module.exports = __webpack_public_path__ + "images/emoji/pouch.ef3f6fc27783eca2662e.png";